







import { Component, Vue } from 'vue-property-decorator';
import AzureAuth from '@/plugins/AzureAuth';

@Component({})
export default class AuthSidebarBottom extends Vue {
  logout() {
    AzureAuth.logout();
  }
}
